module.exports = __webpack_public_path__ + "img/w12-cover.71ca2101.jpg";